function length(message, limit) {
    return (value) => {
        if (value === null || value === undefined || value === '') {
            return;
        }
        if (value.length !== limit) {
            throw new Error(message);
        }
    };
}
export default length;
